import React from "react";
import "./SignupModal.css";

const SignupModal = ({
  activeTab,
  setActiveTab,
  showOtpLogin,
  setShowOtpLogin,
  handleSignUp,
  handleSendOtp,
  handleVerifyOtp,
  phoneNumber,
  setPhoneNumber,
  otp,
  setOtp,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  setEmail,
}) => {
  return (
    <div
      className="modal fade"
      id="signupModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header  text-white" style={{backgroundColor:" #002989"}}>
            <h5 className="modal-title">Sign Up / Log In</h5>
            <button
              type="button"
              className="btn-close text-bg-light"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form>
              {/* Step 1: Phone Number */}
              {!showOtpLogin && (
                <>
                  <div className="mb-3">
                    <label htmlFor="phoneNumber" className="form-label">
                      Enter Mobile Number
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phoneNumber"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100"
                    onClick={handleSendOtp}
                  >
                    Get OTP
                  </button>
                </>
              )}

              {/* Step 2: Enter OTP */}
              {showOtpLogin && (
                <>
                  <div className="mb-3 mt-3">
                    <label htmlFor="otp" className="form-label">
                      Enter OTP
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="otp"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-primary w-100"
                    onClick={handleVerifyOtp}
                  >
                    Verify OTP
                  </button>
                </>
              )}

              {/* Step 3: Show signup fields if user is new */}
              {activeTab === "signup" && showOtpLogin && (
                <>
                  <hr />
                  <div className="mb-3 mt-3">
                    <label htmlFor="firstName" className="form-label">
                      First Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="firstName"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="lastName" className="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="lastName"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-outline-success w-100"
                    onClick={handleSignUp}
                  >
                    Sign Up
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupModal;
